module.exports = __webpack_public_path__ + "img/feedback.54e5f739.png";